import { useEffect, useRef } from "react";
import { Card, CardContent } from "../components/ui/card"; // à garder ou retirer selon ton usage

export default function AdScriptCard({ scriptSrc }) {
    useEffect(() => {
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src =  scriptSrc; 
        script.async = true;
    
        document.head.appendChild(script);
    
        return () => {
          // Nettoyage si on quitte la page
          document.head.removeChild(script);
        };
      }, [scriptSrc]);
    
      return null; // pas d'affichage
}
